import request from "@/shared/api/request";

import type {
  ListSubscriptionPlansResponse,
  SubscriptionOverviewResponse,
  SubscriptionOrdersResponse,
} from "./types";

export const getSubscriptionPlans = (): Promise<ListSubscriptionPlansResponse> =>
  request.get("/api/v1/subscription-plans");

export const getSubscriptionOverview = (): Promise<SubscriptionOverviewResponse> =>
  request.get("/api/v1/users/me/subscription-overview");

export const getSubscriptionOrders = (page: number, limit = 10): Promise<SubscriptionOrdersResponse> =>
  request.get("/api/v1/subscription-orders", { page, limit });
